import React, { Component } from "react";
import { DynamicFormFieldProps } from "../DynamicForm";
import { DynamicFormField, DynamicFormValidation } from "../../laco-common/base/form-validation/dynamic";
import { ISelectFormField, IFormField } from "../../laco-common";
import { WithOptional } from "../../laco-common/helpers/extendedTypes";
import ItemFormInput from "./ItemForm";
import { IAudioFile } from "../../models/audio";
import { IImage, getFileType } from "../../models/Image";
import { UploadMode, MediaAccepted } from "../../laco-common/base/models/upload";

const getAudioFields = (
	data: IAudioFile
): Record<
	keyof Partial<IAudioFile>,
	DynamicFormField & WithOptional<Partial<ISelectFormField>, "id" | "fieldType">
> => {
	return {
		title: { order: 0, value: data?.title, label: "Title", optional: true, fieldType: "text" },
		subHeading: { order: 10, value: data?.subHeading, label: "Sub Heading", optional: true, fieldType: "textarea" },
		url: {
			order: 20,
			value: data?.url,
			label: "Recording",
			fieldType: "media",
			optional: true,
			mediaOptions: {
				maxFileCount: 1,
				mode: UploadMode.SINGLE,
				path: "site/audio",
				mediaAccepted: MediaAccepted.AUDIO,
			},
		},
		thumbUrl: {
			order: 30,
			value: data?.thumbUrl,
			label: "Image",
			fieldType: "imageUrl",
			optional: true,
			mediaOptions: {
				maxFileCount: 1,
				mode: UploadMode.SINGLE,
				mediaAccepted: MediaAccepted.IMAGE_VIDEO,
			},
		},
	} as any;
};

const getImageFields = (
	data: IImage,
	fieldKey: string
): Record<keyof Partial<IImage>, DynamicFormField & WithOptional<Partial<ISelectFormField>, "id" | "fieldType">> => {
	return {
		title: { order: 0, value: data?.title, label: "Title", optional: true },
		desc: { order: 10, value: data?.desc, label: "Description", optional: true },
		// filename: { order: 20, value: data?.filename, label: "Description", optional: true },
		[fieldKey]: {
			order: 30,
			value: data ? data[fieldKey] : "",
			label: "Image",
			fieldType: "media",
			optional: true, // simba TODO: causes blur and validation error
			mediaOptions: {
				maxFileCount: 1,
				mode: UploadMode.SINGLE,
				path: "site/galleries",
				mediaAccepted: MediaAccepted.IMAGE_VIDEO,
			},
		},
		mediaDate: { order: 50, value: data?.mediaDate, label: "Date", optional: true, fieldType: "date" },
		// thumbUrl: { order: 30, value: data?.thumbUrl, label: "Image file", fieldType: "imageUrl", optional: true },
	} as any;
};

export default class MediaInput extends Component<DynamicFormFieldProps> {
	onMediaFormChange(field: keyof IImage, form: DynamicFormValidation, i: number) {
		console.log("MediaInput onMediaFormChange(): field, index, form:", field, i, form);
		const updatedArr: IImage[] = [...this.props.field.value];
		(updatedArr[i] as any) = form.values;
		console.log("updatedImagesArr:", updatedArr);
		const newFilename = form.fields.filename.value;
		updatedArr[i].fileType = getFileType(newFilename);
		this.props.onChange(updatedArr);
	}

	render() {
		const { onChange, ...other } = this.props;

		switch ((this.props.field as any as IFormField).mediaOptions?.mediaAccepted) {
			case MediaAccepted.AUDIO: {
				return (
					<ItemFormInput
						{...this.props}
						itemName="Recording"
						nameField="title"
						viewItemSelector=".audio-container"
						getFields={getAudioFields}
						createNew={() => {
							return { title: "Sample title", subHeading: "Interview Title" } as any;
						}}
					/>
				);
			}
			case MediaAccepted.IMAGE_VIDEO:
			case MediaAccepted.IMAGE:
			case MediaAccepted.VIDEO:
			default: {
				return (
					<ItemFormInput
						{...other}
						itemName="Media"
						nameField="title"
						viewItemSelector=".mss-image-view"
						getFields={(data) => getImageFields(data, "filename")}
						createNew={() => {
							return { title: "Sample title" } as any;
						}}
						onChange={(images: IImage[]) => {
							this.props.onChange(images);
						}}
						onFormChange={this.onMediaFormChange.bind(this)}
					/>
				);
			}
		}
	}
}
